import { render, staticRenderFns } from "./cabinetDoor.vue?vue&type=template&id=2c069cc8&scoped=true"
import script from "./cabinetDoor.vue?vue&type=script&lang=js"
export * from "./cabinetDoor.vue?vue&type=script&lang=js"
import style0 from "./cabinetDoor.vue?vue&type=style&index=0&id=2c069cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c069cc8",
  null
  
)

export default component.exports